// extracted by mini-css-extract-plugin
export default {"loading-overlay":"App_loading-overlay__Py0hn","overlay":"App_overlay__S8m0q"};